export default __webpack_public_path__ + "static/media/LEGA9071.2e6b027c.jpg";